import {Button, Card, Spin} from "antd";
import React, {useEffect, useState} from "react";
import {UserOutlined} from "@ant-design/icons";
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import {getPatientApi} from "../../api/apiInstances";
import logger from "../../utils/logger";

const DashboardPatientsCard = () => {
    const [count, setCount] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(true);

    const patientsApi = getPatientApi();

    useEffect(() => {
        patientsApi.fetchPatientsCount()
            .then(res => {
                setCount(res.data);
                setLoading(false);
            })
            .catch(err => {
                logger.log(err);
                setLoading(false);
            });
    }, []);

    return (
        <Card bordered={true}
              styles={{body: {padding: '0'}}}
              style={{height: 336}}
              className="dentobook-dashboard-card dentobook-dashboard-calendar-card">
            <span className="font-24">
                <span className="text-blue mr-1"><UserOutlined/></span> {<FormattedMessage id="patients"/>}
            </span>
            {loading ? (
                <div style={{ textAlign: 'center', padding: '80px 0' }}>
                    <Spin />
                </div>
            ) : (
                <div style={{textAlign: 'center'}}>
                    <h1 className='dentobook-dashboard-patients-count'>{count}</h1>
                    <Link to="/patients/create" style={{display: 'inline-block', marginTop: '56px'}}>
                        <Button className="dentobook-btn-secondary dentobook-btn-medium" style={{margin: "auto"}}>
                            <FormattedMessage id='saveNew'/>
                        </Button>
                    </Link>
                </div>
            )}
        </Card>
    )
}

export default DashboardPatientsCard;

